import { pushToDataLayer } from './dataLayer';

const pushHero = (event, surface, props = {}) =>
  pushToDataLayer({ event, surface, ...props });

export const trackHeroSearchFocus = surface =>
  pushHero('hero_search_focus', surface);

export const trackHeroSearchQuery = (
  surface,
  { query, resultsCountProducts, resultsCountCategories, latencyMs }
) =>
  pushHero('hero_search_query', surface, {
    query,
    results_count_products: resultsCountProducts,
    results_count_categories: resultsCountCategories,
    latency_ms: latencyMs,
  });

export const trackHeroSearchZeroResults = (surface, { query }) =>
  pushHero('hero_search_zero_results', surface, { query });

export const trackHeroSearchSelectProduct = (
  surface,
  { query, productSlug, position, section }
) =>
  pushHero('hero_search_select_product', surface, {
    query,
    product_slug: productSlug,
    position,
    section,
  });

export const trackHeroSearchSelectFreetext = (surface, { query, source }) =>
  pushHero('hero_search_select_freetext', surface, { query, source });

export const trackHeroSearchClear = surface =>
  pushHero('hero_search_clear', surface);

export const trackHeroSearchError = (surface, { errorType, query }) =>
  pushHero('hero_search_error', surface, { error_type: errorType, query });

export const trackHeroContactFormOpen = (surface, { source }) =>
  pushHero('hero_contact_form_open', surface, { source });
